import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {KamonaFormButtonType} from '../../../model/kamonal-model';

@Component({
	selector: 'app-form-button-template',
	templateUrl: './form-button-template.component.html',
	styleUrls: ['./form-button-template.component.scss']
})
export class FormButtonTemplateComponent implements OnInit {
	@Input() kamonaFormButtonType: KamonaFormButtonType;
	KamonaDialogButtonType = KamonaFormButtonType;
	@Input() closeBtn: string;
	@Input() disableButton;
	@Input() submitBtn: string;
	@Input() loadingAfterSubmit: boolean;
	@Input() isMobile: boolean;
	@Input() submitting: boolean;
	@Input() spacing = 40; // In px
	@Input() minWidthSubmitBtn = 80; // In px
	loading: boolean;
	@Output() emitClose = new EventEmitter();
	@Output() emitSubmit = new EventEmitter();

	constructor() {
	}

	ngOnInit(): void {
	}

	submit() {
		this.emitSubmit.emit();
		if (this.loadingAfterSubmit) {
			this.loading = true;
		}
	}

	close() {
		this.emitClose.emit();
	}

}
